export default "__VITE_ASSET__081cae79__"